<div class="h-full min-h-[180px] w-full min-w-0 bg-transparent p-2">
  <dx-pie-chart
    *ngIf="isPieChart"
    class="h-full w-full"
    [dataSource]="chartDataSource"
    [type]="chartType"
    [palette]="chartPalette">
    <dxi-series [argumentField]="chartArgumentField" [valueField]="chartValueField">
      <dxo-label [visible]="chartLabelsVisible"></dxo-label>
    </dxi-series>
    <dxo-legend [visible]="chartLegendVisible"></dxo-legend>
    <dxo-tooltip [enabled]="true"></dxo-tooltip>
  </dx-pie-chart>

  <dx-chart
    *ngIf="!isPieChart"
    class="h-full w-full"
    [dataSource]="chartDataSource"
    [rotated]="chartRotated"
    [palette]="chartPalette">
    <dxi-series
      *ngFor="let series of chartSeries"
      [argumentField]="series.argumentField"
      [valueField]="series.valueField"
      [name]="series.name"
      [type]="series.type">
    </dxi-series>
    <dxo-legend [visible]="chartLegendVisible"></dxo-legend>
    <dxo-tooltip [enabled]="true"></dxo-tooltip>
  </dx-chart>
</div>
